import { AlertThresholdOperator } from '../../enums/alert-threshold-operator';
import { AlertSeverityLevel } from '../../enums/alert-severity-level';

export class BuilderQuestionSetAlertThreshold {
  threshold: number;
  operator: AlertThresholdOperator;
  alertSeverityLevel: AlertSeverityLevel;

  constructor() {
    this.threshold = 0;
    this.operator = AlertThresholdOperator.Equals;
    this.alertSeverityLevel = AlertSeverityLevel.Medium;
  }
}
